import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import semenProgramListAction from './semenProgramList.action.json' with { type: 'json' }
import { semenProgramObject } from '../semenProgramObject'

export const semenProgramExpression = expression(semenProgramObject.shape)

const semenProgramListDefinition = defineAction({
  ...semenProgramListAction,

  input: z.object({
    filter: semenProgramExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      name: 'Nome',
      usageLimit: 'Limite de uso',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(semenProgramObject),
    count: z.number(),
  }),
})

export default semenProgramListDefinition
